import { view, cssGenerator } from '@yola/ws-sdk';

const { COLUMN_WIDTH } = cssGenerator.constants.attributes;

const prepareInstructionsForColumnWidthReset = (elementId) => {
  const instructions = {};
  const columns = view.accessors.getLiveElement(elementId);
  const customWidthColumns = columns.querySelectorAll(`ws-column[${COLUMN_WIDTH}]`);

  if (customWidthColumns.length) {
    customWidthColumns.forEach((column) => {
      const columnId = view.accessors.getLiveElementId(column);
      instructions[columnId] = {
        [COLUMN_WIDTH]: false,
      };
    });
  }

  return instructions;
};

export default prepareInstructionsForColumnWidthReset;
